import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";

import Button from "../../../components/Button";
import Dialog from "../../../components/Dialog";
import InfoBox from "../../../components/InfoBox";
import BankAccountDetails from "../../../components/BankAccountDetails";
import EmptyAccountState from "../../../components/EmptyAccountState";
import TextInput from "../../../components/TextInput";
import { useAppState } from "../../../contexts/AppContext";
import { useGetVirtualTerminals } from "../../../hooks/useGetVirtualTerminal";
import { requireRouteAccess } from "../../../utils/authorization";

export const Route = createFileRoute("/_app/collections/")({
  beforeLoad: () => requireRouteAccess("/collections"),
  component: Collections,
});

function Collections() {
  const {
    state: { business },
  } = useAppState();
  const businessId = business?.id as string;
  const [dialogOpen, setDialogOpen] = useState(false);
  const handleDialogVisibility = () => {
    setDialogOpen(!dialogOpen);
  };

  const { data: virtualTerminals } = useGetVirtualTerminals(businessId);

  return (
    <>
      <div>
        <InfoBox infoText="With your virtual terminal, you can receive payments from your customers directly into your account and get instant alerts on your Whatsapp number when they do." />

        <Button variant="primary" onClick={handleDialogVisibility}>
          Create virtual terminal
        </Button>

        <div className="pt-8 w-full">
          <p>Your Virtual Terminal(s)</p>
          {virtualTerminals.length === 0 && (
            <EmptyAccountState
              title="No Virtual Terminal Yet"
              body="Your virtual terminals will appear here once they are created"
            />
          )}
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 mt-4 gap-6">
            {virtualTerminals.map((virtualTerminal) =>
              virtualTerminal.paymentMethods.map((paymentMethod) => (
                <div
                  key={paymentMethod.accountNumber}
                  className="border rounded-md bg-white p-6"
                >
                  <BankAccountDetails
                    bankName={paymentMethod.bankName}
                    accountName={paymentMethod.accountName}
                    accountNumber={paymentMethod.accountNumber}
                  />
                </div>
              )),
            )}
          </div>
        </div>

        <Dialog isOpen={dialogOpen} onClose={handleDialogVisibility}>
          <div className="px-8 py-6 md:w-[480px] w-[360px]">
            <p className="font-bold text-lg pb-4">Create a virtual terminal</p>
            <p className="font-bold text-sm text-gray-500 pb-4">
              An account number will be generated for you to collect payments
              from your customers.
            </p>
            <p className="font-bold pb-2">Terminal Name</p>
            <TextInput placeholder="e.g Store Name 1" />
            <p className="font-bold pb-2 mt-4">Whatsapp Number</p>
            <TextInput placeholder="e.g Store Name 1" />
            <p className="text-gray-400 text-xs mt-2">
              You will receive payments notifications on this number. Customers
              will not have access to it.
            </p>

            <div className="flex justify-end">
              <Button variant="primary" className="mt-8">
                Create virtual terminal
              </Button>
            </div>
          </div>
        </Dialog>
      </div>
    </>
  );
}
